
document.addEventListener("input", function() {
  let inputs = document.querySelectorAll("input[type='number']");
  let total = 0;
  inputs.forEach(i => total += parseInt(i.value)||0);

  let price = 8.99;
  let discount = 0;

  if (total >= 48) discount = 0.10;
  else if (total >= 24) discount = 0.06;
  else if (total >= 12) discount = 0.03;

  let subtotal = total * price;
  let savings = subtotal * discount;
  let finalTotal = subtotal - savings;

  let t = document.getElementById("bulk_total_units");
  let s = document.getElementById("bulk_savings");
  let e = document.getElementById("bulk_estimated");

  if(t) t.innerText = total;
  if(s) s.innerText = "$" + savings.toFixed(2);
  if(e) e.innerText = "$" + finalTotal.toFixed(2);
});
